import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import './index.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';

const publishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY?.trim() || 'pk_live_Y2xlcmsuYXN0cm9zdGFyLmJpeiQ';
// const clerkDomain = process.env.REACT_APP_CLERK_DOMAIN?.trim();
// const clerkProps = clerkDomain ? { domain: clerkDomain, isSatellite: true } : {};

const routerPush = (to: string) => {
  if (typeof window !== 'undefined') {
    window.history.pushState({}, '', to);
  }
};

const routerReplace = (to: string) => {
  if (typeof window !== 'undefined') {
    window.history.replaceState({}, '', to);
  }
};

if (!publishableKey) {
  console.error('Clerk publishable key is missing. Set REACT_APP_CLERK_PUBLISHABLE_KEY for this environment.');
}

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={publishableKey}
      // {...clerkProps}
      routerPush={routerPush}
      routerReplace={routerReplace}
    >
      <App />
    </ClerkProvider>
  </React.StrictMode>
);

//reportWebVitals();
